import Icon from '@material-ui/icons/Settings';
import { SettingEdit } from './SettingEdit';
import { SettingList } from './SettingList';

export default {
  icon: Icon,
  edit: SettingEdit,
  list: SettingList,
};
